<template>
<div class="chapter">
<div class="inner_page">
<p class="blockquote"><a id="ch00_fm06"></a><a id="page_5"></a><em>‘And he laid hold on the dragon, that old serpent, which is the Devil, and Satan, and bound him a thousand years.’</em></p>
<p class="attribution"><em>Revelation 20:2</em><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?5241c11a